import { callAxios, customToast, dev_console, isSuccess, whoAmI } from "../../../../Common/ts/commonTools";
import { ProductDetail_Interface } from "../../static/interface/ProductDetail.interface";
import { defaultApiReaponseInterface } from "../../../../Common/interface/Common.interface";
import { useCallback, useEffect, useMemo } from "react";
import { RTN_interface } from "../../../../Common/interface/App.interface";
import useCustomQuery from "../../../../Common/hooks/useCustomQuery";

const TOAST_ID = "useProductDetailREST";

const useProductDetailREST = (
    {
        contract_product_id,
        album_save_id,
        photo_upload_id
    }:{
        contract_product_id: number;
        album_save_id: number | null;
        photo_upload_id: number | null;
    }
) => {
    // 1. 요청 가능 여부 계산
    const isAbleToRequest = useMemo(() => {
        return whoAmI.isCustomer() && !!contract_product_id;
    }, [contract_product_id]);

    // 2. API 호출 함수 메모이제이션 (중요: useCallback 사용)
    // 의존성 배열에 변수들을 넣어 값이 바뀔 때만 함수가 재생성되도록 함
    const callProductDetailData = useCallback(async () => {
        const product_detail_url = `api/v3/oops/product-detail2?contract_product_id=${contract_product_id || ""}&album_save_id=${album_save_id || ""}&photo_upload_id=${photo_upload_id || ""}`;

        const RTN = await callAxios.api({
            url: product_detail_url,
            method: "get"
        });

        dev_console.log(product_detail_url);
        dev_console.log(RTN);

        return RTN;
    }, [contract_product_id, album_save_id, photo_upload_id]);

    // 3. Select 함수 메모이제이션 (중요: useCallback 사용)
    const selectProductDetail = useCallback((response: any) => {
        const RTN: RTN_interface<ProductDetail_Interface | null> = {
            sign: false,
            data: null,
            msg: "",
        };

        // 즉시 실행 함수 블록 대신 일반 로직으로 처리
        if (!isSuccess(response)) {
            RTN.msg = "제품의 상세정보 요청 과정에서 문제가 발생했습니다.";
            // 주의: select 내부에서 Toast를 띄우는 것은 Side Effect이므로 지양해야 하나,
            // 기존 로직 유지를 위해 남겨둔다면 반드시 useCallback으로 감싸야 합니다.
            // 가장 좋은 방법은 여기서 데이터를 null로 리턴하고 useEffect에서 처리하는 것입니다.
            return null;
        }

        const data: defaultApiReaponseInterface<ProductDetail_Interface> = response.data;
        RTN.sign = true;
        RTN.data = data.result;

        return RTN.data;
    }, []); // 의존성이 없다면 빈 배열

    const {
        data: productDetailData = null,
        error: productDetailError,
        isLoading: productDetailIsLoading,
        refetch: productDetailRefetch,
    } = useCustomQuery({
        // queryKey에 변수들이 포함되어 있으므로, 변수 변경 시 자동으로 refetch 됩니다.
        queryKey: ["useProductDetailREST", contract_product_id, album_save_id, photo_upload_id],
        queryFn: callProductDetailData, // 메모이제이션 된 함수 전달
        enabled: isAbleToRequest,
        select: selectProductDetail,    // 메모이제이션 된 함수 전달
    });

    useEffect(() => {
        if(productDetailError){
            customToast.error({
                msg: "제품의 상세정보 요청 과정에서 문제가 발생했습니다.",
                toastId: TOAST_ID
            })
        }
    }, [productDetailError])

    return({
        productDetailData,
        productDetailError,
        productDetailIsLoading,
        productDetailRefetch
    })
}

export default useProductDetailREST;